<template>
    <div>
        <div class="auth-input-container">
            <b-form-group id="fieldset-password" label="Neues Passwort" label-for="input-password">
                <b-form-input
                    id="input-password"
                    ref="password"
                    v-model="password"
                    v-validate="'required'"
                    name="password"
                    :type="showPassword ? 'text' : 'password'"
                    placeholder="Bitte tragen Sie ihr neues Passwort ein"
                    :state="checkState('password')"
                />
            </b-form-group>
        </div>
        <div class="auth-input-container">
            <b-form-group
                id="fieldset-repeatpassword"
                label="Neues Passwort bestätigen"
                label-for="input-repeatpassword"
            >
                <b-form-input
                    id="input-repeatpassword"
                    v-model="repeatPassword"
                    v-validate="'required|confirmed:password'"
                    name="repeatpassword"
                    :type="showPassword ? 'text' : 'password'"
                    placeholder="Passwort bestätigen"
                    :state="checkState('repeatpassword')"
                />
            </b-form-group>
        </div>
        <b-check v-model="showPassword">Passwort anzeigen</b-check>
    </div>
</template>

<script>
export default {
    name: "RepeatPasswordVue",
    props: {
        value: {
            type: String,
            default: () => ""
        }
    },
    data() {
        return {
            password: this.value,
            repeatPassword: "",
            showPassword: false
        };
    },
    computed: {
        isGoodPassword() {
            // TODO
            return true;
        }
    },
    watch: {
        repeatPassword: function(value) {
            if (value === this.password && this.isGoodPassword) {
                console.log("psst");
                this.$emit("input", value);
            }
        }
    }
};
</script>

<style scoped></style>
